import classnames from 'classnames';
import type { HTMLProps } from 'react';

type Props = {
  className?: string;
  shown?: boolean;
  onTransitionEnd?: HTMLProps<HTMLElement>['onTransitionEnd'];
  children?: React.ReactNode;
};

const DrawerPanel: React.FC<Props> = ({
  children,
  className,
  onTransitionEnd,
  shown,
}) => {
  return (
    <div
      className={classnames(
        'fixed w-full transition-all duration-500 md:w-1/2',
        shown ? 'right-0' : '-right-full',
        shown ? 'pointer-events-auto' : 'pointer-events-none',
        className,
      )}
      onTransitionEnd={onTransitionEnd}
    >
      {children}
    </div>
  );
};

export default DrawerPanel;
